/**
 * Adds a bilingual confidentiality disclaimer to a jsPDF page.
 * Called inside each addPageTemplate() function.
 */
export function addPdfDisclaimer(doc) {
  const clubName = localStorage.getItem('clubName') || 'Club';
  const pageWidth = doc.internal.pageSize.width;
  const pageHeight = doc.internal.pageSize.height;

  const disclaimerY = pageHeight - 6;

  doc.setFontSize(4.5);
  doc.setTextColor(150, 150, 150);
  doc.text(
    `CONFIDENTIAL \u2013 Property of ${clubName}. Any use, reproduction, modification, distribution, display, or performance of this material without ${clubName}\u2019s prior written consent is prohibited.`,
    pageWidth / 2,
    disclaimerY,
    { align: 'center', maxWidth: pageWidth - 30 }
  );
  doc.text(
    `CONFIDENTIAL \u2013 Propiedad de ${clubName}. Queda prohibido cualquier uso, reproducci\u00f3n, modificaci\u00f3n, distribuci\u00f3n, exhibici\u00f3n o ejecuci\u00f3n de este material sin el consentimiento previo y por escrito de ${clubName}.`,
    pageWidth / 2,
    disclaimerY + 2.5,
    { align: 'center', maxWidth: pageWidth - 30 }
  );
  doc.setTextColor(0, 0, 0);
}
